module.exports = __webpack_public_path__ + "img/a3-s10.488cfb09.jpg";